import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import * as IoC from 'typescript-ioc';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import Text from '../../../global/text/text';

interface IProps {
    eventTimezone: string;
    onSelect: (date?: Date) => void;
    filterDatesList: Date[];
    selectedDate: Date | null;
}

const DateSelectionDropdown = (props: IProps) => {
    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const { eventTimezone, filterDatesList, onSelect, selectedDate } = props;

    const [isOpen, setIsOpen] = useState(false);

    const onDropdownClick = () => {
        setIsOpen(!isOpen);
    };

    const handleSelectDate = date => {
        if (selectedDate?.toString() !== date.toString()) {
            onSelect(date);
        }
        setIsOpen(false);
    };

    return (
        <div className='multi-selection-dropdown'>
            <div
                onClick={onDropdownClick}
                className={classnames('cell-header-btn', {'cell-header-btn--active': isOpen || selectedDate})}
            >
                <Text id='oe.common.dateAndTime' description='Label text' message='Date and Time' withEllipsis/>
            </div>

            {isOpen &&
            <>
                <div className='multi-selection-dropdown__overlay' onClick={() => setIsOpen(false)}/>
                <div className='multi-selection-dropdown__options'>
                    {filterDatesList.length ? (
                        filterDatesList.map(day => {
                            const dayStringInEventTimezone = dateTimeFormatter.dateToFormattedString(
                                day,
                                DateFnsFormats.StringifiedShortDay,
                                eventTimezone
                            );

                            return (
                                <div
                                    className={classnames('multi-select__option', {
                                        'multi-select__option--selected': selectedDate?.toString() === day.toString()
                                    })}
                                    key={day.toString()}
                                    onClick={() => handleSelectDate(day)}>
                                    {dayStringInEventTimezone}
                                </div>
                            );
                            })
                    ) : (
                        <div className='p-10px'>
                            <FormattedMessage
                                id='oe.connections.noDatesFound'
                                description='Placeholder for dates popover'
                                defaultMessage='No dates found'
                            />
                        </div>
                    )}
                </div>
            </>
            }
        </div>
    );
};

export default DateSelectionDropdown;
